/* eslint-disable no-param-reassign */

function seeMore() {
  const btnSeeMore = document.querySelector('#btn-see-more');
  const element = document.querySelector('.disclaimer-main-text');
  const disclaimerBody = document.querySelector('#disclaimer-body');

  if (!btnSeeMore || !element || !disclaimerBody) return;

  let expanded = false;
  const disclaimerBodyHeight = disclaimerBody.getBoundingClientRect().height;

  if (disclaimerBodyHeight > 200) {
    btnSeeMore.style.display = 'flex';
  }

  const buttonLabel = btnSeeMore.querySelector('.button__label');
  const buttonIcon = btnSeeMore.querySelector('.button__arrow');

  btnSeeMore.addEventListener('click', () => {
    if (!expanded) {
      element.style.maxHeight = '5000px';
      buttonLabel.innerText = 'See less';
      buttonIcon.innerText = '−';
      expanded = true;
    } else {
      element.style.maxHeight = '';
      buttonLabel.innerText = 'See more';
      buttonIcon.innerText = '+';
      expanded = false;
    }
  });
}

((Drupal, $) => {
  seeMore();
  $(document).ajaxComplete(() => {
    seeMore();
  });
})(Drupal, jQuery);
